import { render, staticRenderFns } from "./AccountIcon.vue?vue&type=template&id=5db372d8&scoped=true&"
import script from "./AccountIcon.vue?vue&type=script&lang=ts&"
export * from "./AccountIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AccountIcon.vue?vue&type=style&index=0&id=5db372d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db372d8",
  null
  
)

export default component.exports